import type { Page } from '@shared/types/Tilelist';
import { calculateLastPage, calculatePage } from '@tilelist/domain/composition/Pagination.ts';
import type { IntentCounts, Pagination } from '@tilelist/domain/composition/Pagination.ts';

export type ComboIntentCounts = IntentCounts & {
    /*                                                                     */
    comboShown?: boolean;
};

/**
 *
 *
 *
 *
 *
 *
 */
export function getOffsetShift(
    offset: number,
    maxItemsPerPage: number,
    comboShown: boolean | undefined,
    pageItemCount?: number,
): 0 | 1 {
    if (pageItemCount !== undefined) return 0;
    if (offset === 0) return comboShown ? 1 : 0;
    return (offset + 1) % maxItemsPerPage === 0 ? 1 : 0;
}

/*                                                                   */
export function getComboPagination(
    { rankedCount, sponsoredCount, pageItemCount, comboShown }: ComboIntentCounts,
    page: Page,
): Pagination {
    const PER_PAGE = 120;
    const THRESHOLD = PER_PAGE / 2;
    const currentOffset = Number.parseInt(page.o || '0', 10);
    const perPageWithSPA = PER_PAGE - sponsoredCount;
    const shift = getOffsetShift(currentOffset, perPageWithSPA, comboShown, pageItemCount);
    const currentPage = calculatePage(currentOffset > 0 ? currentOffset + shift : 0, perPageWithSPA, THRESHOLD);
    const lastPage = calculateLastPage(rankedCount + shift, perPageWithSPA);

    return { currentPage, currentOffset, lastPage };
}
